import {useState, useEffect} from "react";
import useTaskMsg from "../taskMessage/index.js";
import useTurms from "../turms/index.js";
import useCs from "../cs/index.js";


export default function useLevelMsgTask() {
    const {emitLeaveMessage} = useTaskMsg()
    const {getTurms} = useTurms()
    const {getCsId} = useCs()

    const turms = getTurms()

    // 启动计时 - 超时则启动任务
    const [levelMsgTask, updateLevelMsgTask] = useState({
        speed: 0,
        status: false
    })

    let timer = null

    // 查询是否已经发送过
    const queryLevelMsg = async () => {
        const csId = await getCsId()
        const res = await turms.messageService.queryMessages({
            fromIds: [csId],
            areGroupMessages: false,
            size: 100,
            hasSelfMessages: true,
            messageType: 6
        })
        if (res.code === 1000 || res.code === 1001) {
            //    是否存在 - 留言短信
            const levelMsgResult = res.data.find(msg => {
                const text = JSON.parse(msg.text)
                return text.type === 3
            })
            return !!levelMsgResult
        }

        return false
    }

    // 清除
    const clear = () => {
        timer !== null && clearInterval(timer)
        updateLevelMsgTask(_ => {
            return {
                speed: 0,
                status: false
            }
        })
    }

    // 启动
    const setup = (speed = 30) => {
        // 重置
        updateLevelMsgTask(() => {
            return {
                speed,
                status: true
            }
        })
    }

    // 重置时间
    const initSpeed = (speed) => {
        updateLevelMsgTask(() => {
            return {
                speed,
                status: true
            }
        })
    }

    useEffect(() => {
        timer = setInterval(() => {
            if (levelMsgTask.speed > 0) {
                updateLevelMsgTask(preStatus => {
                    return {
                        speed: preStatus.speed - 1,
                        status: true
                    }
                })
            }
        }, 1000)

        // console.log("什么情况", levelMsgTask.status && levelMsgTask.speed === 0, levelMsgTask)
        if (levelMsgTask.status && levelMsgTask.speed === 0) {
            console.log(timer, 'timer')
            clearInterval(timer)
            updateLevelMsgTask({
                speed: 0,
                status: false
            })
            // 调出 - 留言信息
            queryLevelMsg().then(result => {
                if (!result) {
                    console.log("留言")
                    emitLeaveMessage().then(() => {
                        console.log("调出留言信息")
                    })
                }
            })

        }

        return () => {
            clearInterval(timer)
        }

    }, [levelMsgTask])

    return {
        clear,
        setup,
        initSpeed,
        queryLevelMsg
    }
}
